
<template>
    <div class="mapMenu" :class="[pc?'menuBox1':'menuBox']" v-loading="loading">
        <div class="tabPlaceholder"></div>
        <div class="tabs">
            <div class="tab " :class="{active:tabState==='1'}" @click="tabSwitch('1');buriedPt('cn:experience store:map','o')">
                <img v-show="tabState==='1'" src="../../assets/img/tab-1.png" alt="">
                <img v-show="tabState!=='1'" src="../../assets/img/tab-5.png" alt="">
                <p class="">查看地图</p>
            </div>
            <div class="tab" :class="{active:tabState==='2'}" @click="tabSwitch('2');buriedPt('cn:experience store:storelist','o')">
                <img v-show="tabState==='2'" src="../../assets/img/tab-2.png" alt="">
                <img v-show="tabState!=='2'" src="../../assets/img/tab-6.png" alt="">
                <p class="">门店查询</p>
            </div>
            <!-- <div class="tab" :class="{active:tabState==='3'}" @click="tabSwitch('3')">
                <img v-show="tabState==='3'" src="../../assets/img/tab-3.png" alt="">
                <img v-show="tabState!=='3'" src="../../assets/img/tab-7.png" alt="">
                <p class="">服务中心</p>
            </div> -->
            <div class="tab" :class="{active:tabState==='4'}" @click="tabSwitch('4');buriedPt('cn:experience store:search','o')">
                <img v-show="tabState==='4'" src="../../assets/img/tab-4.png" alt="">
                <img v-show="tabState!=='4'" src="../../assets/img/tab-8.png" alt="">
                <p class="">搜索</p>
            </div>
        </div>
        <div class="content" v-show="tabState!=='1'"  v-infinite-scroll="load" infinite-scroll-distance="10" >
            <div class="action">
                <div class="action-query" v-show="tabState==='2'">
                    <el-select v-model="store_province" ref="configSelect" :popper-append-to-body="false" placeholder="选择省" style="width:100%" class=" elSelect" popper-class="selectCls" @change="store_province_change">
                        <el-option
                        v-for="item in store_province_list"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id">
                        <span class="icon" :class="[pc?'ml60_p':'ml60_m']"></span>
                        <span style="float: left">
                            {{ item.Name }}
                        </span>
                        </el-option>
                    </el-select>
                    <el-select v-model="store_city" ref="configSelect1" :popper-append-to-body="false" placeholder="选择市" style="width:100%" class="mt20_m elSelect" popper-class="selectCls" @change="getCity">
                        <el-option
                        v-for="item in store_city_list"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id">
                        <span class="icon" :class="[pc?'ml60_p':'ml60_m']"></span>
                        <span style="float: left">
                            {{ item.Name }}
                        </span>
                        </el-option>
                    </el-select>
                    <el-select v-model="store_productType" ref="configSelect2" :popper-append-to-body="false" multiple placeholder="选择产品类型" class="mt20_m elSelect" style="width:100%" popper-class="selectCls">
                        <el-option
                        v-for="item in store_productType_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        <span class="icon" :class="[pc?'ml60_p':'ml60_m']"></span>
                        <span style="float: left">
                            {{ item.name }}
                        </span>
                        </el-option>
                    </el-select>
                    <div class="action-query-btn" @click="getStoreList();buriedPt('cn:experience store:query:','o')">
                        查询
                    </div>
                </div>
                <div class="action-query" v-show="tabState==='3'">
                    <el-select v-model="serve_province" ref="configSelect4" placeholder="选择省" :popper-append-to-body="false" style="width:100%" class=" elSelect" popper-class="selectCls" @change="serve_province_change">
                        <el-option
                        v-for="item in serve_province_list"
                        :key="item.ID"
                        :label="item.P"
                        :value="item.P">
                        <span class="icon" :class="[pc?'ml60_p':'ml60_m']"></span>
                        <span style="float: left">
                            {{ item.P }}
                        </span>
                        </el-option>
                    </el-select>
                    <el-select v-model="serve_city" ref="configSelect5" placeholder="选择市" :popper-append-to-body="false" style="width:100%" class="mt20_m elSelect" popper-class="selectCls">
                        <el-option
                        v-for="item in serve_city_list"
                        :key="item.ID"
                        :label="item.C"
                        :value="item.C">
                        <span class="icon" :class="[pc?'ml60_p':'ml60_m']"></span>
                        <span style="float: left">
                            {{ item.C }}
                        </span>
                        </el-option>
                    </el-select>
                    <el-select v-model="serve_productType.label" ref="configSelect6" :popper-append-to-body="false" collapse-tags teleported persistent multiple placeholder="选择产品类型" class="mt20_m elSelect" style="width:100%" :popper-class="pc?'selectCls':'selectCls1'" @remove-tag="removeProductType">
                        <el-option
                        disabled
                        class="productTypeBox">
                            <div class="productType">
                                <el-collapse>
                                    <el-collapse-item v-for="(item,index) in serve_productType_list" :key="item.ID" >
                                        <template #title>
                                            <span class="icon" :class="[pc?'ml60_p':'ml60_m',item.cIdArr.indexOf(serve_productType.value) != -1 ? 'iconS' : '']"></span>
                                            {{item.Name}}
                                        </template>
                                        <div class="tabBox">
                                            <el-tag
                                                v-for="itemC in item.chindren"
                                                :key="itemC.ID"
                                                type="info"
                                                class="mr10 mb10 pointer"
                                                :class="{'tagSelect':serve_productType.value === itemC.ID}"
                                                effect="plain"
                                                round
                                                @click="chooseTyle(itemC)"
                                                >
                                                {{itemC.Name}}
                                            </el-tag>
                                        </div>
                                    </el-collapse-item>
                                </el-collapse>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="action-query-btn" @click="getStationList">
                        查询
                    </div>
                </div>
                <div class="search" v-show="tabState==='4'">
                    <el-collapse accordion v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="请输入门店名称或地址" name="1">
                        <el-input v-model="storeName" class="w-50 m-2 searchInput" placeholder="请输入" @input="input1">
                            <template #suffix>
                            <el-icon class="el-input__icon"><search /></el-icon>
                            </template>
                        </el-input>
                    </el-collapse-item>
                    <!-- <el-collapse-item title="请输入服务中心名称或地址" name="2">
                        <el-input v-model="serverName" class="w-50 m-2" placeholder="请输入" @input="input2">
                            <template #suffix>
                            <el-icon class="el-input__icon"><search /></el-icon>
                            </template>
                        </el-input>
                    </el-collapse-item> -->
                    <el-collapse-item title="快速搜索" name="3">
                        <div class="search-item">
                            <div class="label" :class="{active:labelList.length === labelState.length}" @click="labelSwitchAll">所有</div>
                            <div class="label" v-for="(item,index) in labelList" :key="item.Id" :class="{active:labelState.indexOf(item.Abbr)!=-1}" @click="labelSwitch(item.Abbr)">
                                {{item.KeyWord}}
                            </div>
                        </div>
                    </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
            <div class="list" v-show="list.length || list1.length">
                <template v-if="tabState === '3'">
                    <div class="item1"  v-for="(item,index) in list" :key="item.Tax" @click="checkStore(item,'server')">
                        <div class="itemL">
                            <div class="icon " :class="{icon1:tabState==='3'}">
                                <span class="text1">{{index+1}}</span>
                            </div>
                            <p class="p1">
                                {{item.NAME1}}
                            
                            </p>
                            <p class="p2">{{item.ServiceAddress}}</p>
                            <p class="p3">联系电话：{{item.OfficeCall}}</p>
                            <p class="p4" @click.stop="getDirections(item,'server')">获取路线</p>
                        </div>
                        <div class="itemR">
                            <img src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Flmg.jj20.com%2Fup%2Fallimg%2F1114%2F121420113514%2F201214113514-6-1200.jpg&refer=http%3A%2F%2Flmg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1668841395&t=69167c65a753736d6378c6bf610a8284" alt="">
                        </div>    
                    </div>
                </template>
                <template v-if="tabState === '2'">
                    <template v-if="store_productType.length === 1 && store_productType[0] === 'HHP,TABLET,VPS'">
                        <div class="item1"  v-for="(item,index) in list" :key="item.Tax" @click="checkStore(item,'store');buriedPt('ses:list:' + item.name, 'o')">
                            <div class="itemL">
                                <div class="icon " >
                                    <span class="text1">{{index+1}}</span>
                                </div>
                                <p class="p1">
                                    {{item.name}}
                                
                                </p>
                                <p class="p2">{{item.address}}</p>
                                <p class="p3">联系电话：{{item.tel}}</p>
                                <p class="p4" @click.stop="getDirections(item,'store');buriedPt('ses:list:' + item.name, 'o')">获取路线</p>
                            </div>
                            <div class="itemR">
                                <img v-show="item.picture && item.picture.indexOf('.jpg') != -1" :src="item.picture" alt="">
                            </div>    
                        </div>
                    </template>
                    <template v-else>
                        <div class="item1"  v-for="(item,index) in list" :key="item.Tax" @click="checkStore(item,'store');buriedPt('ses:list:' + item.name, 'o')">
                            <div class="itemL">
                                <div class="icon " :class="{icon1:item.type===2}">
                                    <span class="text1">{{index+1}}</span>
                                </div>
                                <p class="p1">
                                    {{item.name}}
                                
                                </p>
                                <p class="p2">{{item.address}}</p>
                                <p class="p3">联系电话：{{item.tel}}</p>
                                <p class="p4" @click.stop="getDirections(item,'store');buriedPt('ses:list:' + item.name, 'o')">获取路线</p>
                            </div>
                            <div class="itemR">
                                <img v-show="item.picture && item.picture.indexOf('.jpg') != -1" :src="item.picture" alt="">
                            </div>    
                        </div>
                    </template>
                </template>
                <template v-if="tabState === '4'">
                    <div v-for="(item,index) in list1" :key="item.Tax">
                        <div v-if="item.type !== 7" class="item1"  @click="checkStore(item,'search');buriedPt('ses:list:' + item.name, 'o')">
                            <div class="itemL">
                                <div class="icon " :class="{icon1:item.type===2}">
                                    <span class="text1">{{index+1}}</span>
                                </div>
                                <p class="p1">
                                    {{item.name}}
                                
                                </p>
                                <p class="p2">{{item.address}}</p>
                                <p class="p3">联系电话：{{item.tel}}</p>
                                <p class="p4" @click.stop="getDirections(item,'store');buriedPt('ses:list:' + item.name, 'o')">获取路线</p>
                            </div>
                            <div class="itemR">
                                <img v-show="item.picture && item.picture.indexOf('.jpg') != -1" :src="item.picture" alt="">
                            </div>    
                        </div>
                        <div class="item1" v-if="item.type === 7" @click="buriedPt('ses:list:' + item.name, 'o')">
                            <div class="itemL">
                            
                                <p class="p1">
                                    {{item.name}}
                                    
                                </p>
                                <p class="p2">{{item.PrmtInfo}}</p>
                                <p class="p3">{{item.address}}</p>
                                <p class="p3">联系电话：{{item.tel}}</p>
                            </div>
                            <div class="itemR">
                                <img v-show="item.picture && item.picture.indexOf('.jpg') != -1" :src="item.picture" alt="">
                            </div>    
                        </div>
                    </div>
                </template>
                
            </div>
        </div>
        
    </div>
</template>

<script>
import {Search} from "@element-plus/icons";
import { debounce } from '@/util/util'//防抖函数
// import {baiduNavigate} from '@/util/navigation'
import {getMenuData,getPCAData,getStationList,getPCList,getStoreList,getKeyWordList,getQuickSearchList} from '@/api/index'
export default {
    name:'menu',
    components:{
        Search
    },
    props: {
        pc:{
            type:Boolean
        }
    },
    data () {
        return {
            loading:false,
            list:[],
            list1:[],
            tabState:'2',
            labelState:[],
            options: [{
            value: '选项1',
            label: '黄金糕'
            }, {
            value: '选项2',
            label: '双皮奶'
            }, {
            value: '选项3',
            label: '蚵仔煎'
            }, {
            value: '选项4',
            label: '龙须面'
            }, {
            value: '选项5',
            label: '北京烤鸭'
            }],
            activeName1:[],
            // query_productType: [],
            // query_province:'',
            // query_city:'',
            serve_productType: {
                label:[],
                value:null
            },
            serve_productType_list: [],
            serve_province:'',
            serve_province_list:[],
            serve_city:'',
            serve_city_list:[],
            serverName:'',
            storeName:'',
            store_province_list: [],
            store_province:'',
            store_city:'',
            store_city_list:[],
            store_productType:['HHP,TABLET,VPS','CTV,HTS','REF,WM,VC','MNT'],
            store_productType_list:[
                {
                    id: 'HHP,TABLET,VPS',
                    name: '手机/平板/手机配件'
                },
                {
                    id: 'CTV,HTS',
                    name: '电视/家庭音响'
                },
                {
                    id: 'REF,WM,VC',
                    name: '冰箱/洗衣机/吸尘器'
                },
                {
                    id: 'MNT',
                    name: '显示器'
                }
            ],
            activeNames: ['1'],
            labelList:[],
            page:1,
            total:0,
            isPage:true,
            TheCurCity:{p:'',c:''},
            point:{},
            address:{},
            cityName:''
        }
    },
    created(){
        console.log(this.$route.query.typeStr)
        if(this.$route.query.typeStr === '5') {
            this.store_productType = ['CTV,HTS']
        }
        if(this.$route.query.typeStr === '6') {
            this.store_productType = ['REF,WM,VC']
        }
        if(this.$route.query.typeStr === '2') {
            this.store_productType = ['HHP,TABLET,VPS']
        }
    },
    mounted(){
        //服务中心接口
        // this.getPCAData()
        // this.getMenuData()
        //门店查询接口
        // this.getPCList()
        //搜索接口
        this.getKeyWordList()
    },
    methods:{

        buriedPt(parame1,parame2){
            console.log(s,'/*********************************/')
            LinkClick(parame1,parame2)
            // s.pageName = "cn:store:experience store:homepage"
            // s.hier1 = "cn>store>mobile>homepage"
            // s.channel = "cn:store"
            // s.events = "event1"
            // s.prop1 = "cn"
            // s.prop2 = "cn:store"
            // s.prop3 = "cn:store:mobile"
            // s.prop4 = "cn:store:mobile:experience store:homepage"
            // // s.prop6 = "product storelocator"
            // /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
            //  var s_code = s.t();
        },
        // 默认门店查询
        async defStoresTheQuery(address,point){
            console.log(address,point,666666)
            this.point = point
            this.address = address
            await this.getPCList()
            this.store_province_list.forEach(item => {
                if(address.province.includes(item.Name)){
                    this.store_province = item.Id
                }
            })
            await this.getPCList(1)
            this.store_city_list.forEach(item => {
                console.log(address.city.includes(item.Name))
                if(address.city.includes(item.Name)){
                    this.store_city = item.Id
                    this.cityName = item.Name
                }
            })
            // this.TheCurCity.p = this.store_province
            // this.TheCurCity.c = this.store_city
            console.log(this.TheCurCity,5656565656)
            this.getStoreList()
        },
        // 服务中心获取省市
        async getPCAData(type){
            const data = {
                P:this.serve_province
            }
            const res = await getPCAData(data)
            console.log(res)
            if(res.status === 'OK'){
                if(type === 1){
                    this.serve_city_list = res.data
                }else{
                    this.serve_province_list = res.data
                }
            }
        },
        // 门店获取省市
        async getPCList(type){
            const data = {
                Pid:this.store_province?this.store_province:'0'
            }
            this.loading = true
            const res = await getPCList(data)
            this.loading = false
            console.log(res)
            if(res){
                if(type === 1){
                    this.store_city_list = res
                }else{
                    this.store_province_list = res
                }
            }
        },
        serve_province_change(e){
            this.serve_city = ''
            this.getPCAData(1)
        },
        store_province_change(e){
            this.store_city = ''
            this.getPCList(1)
        },
        async getMenuData(){
            const data = {
                
            }
            const res = await getMenuData(data)
            console.log(res)
            if(res.status === 'OK'){
                console.log(res.data)
                // console.log(this.toTree(res.data,'ID','PID','chindren'))
                this.serve_productType_list = this.toTree(res.data,'ID','PID','chindren')
                this.serve_productType_list.forEach((item) => {
                    item.cIdArr = []
                    item.chindren.forEach((itemC => {
                        item.cIdArr.push(itemC.ID)
                    }))

                })
            }
            
        },
        // 获取服务中心数据
        async getStationList(){
            if(!this.serve_province){
                this.$message({
                    message: '请选择省',
                    type: 'warning'
                });
                return
            }
            if(!this.serve_city){
                this.$message({
                    message: '请选择市',
                    type: 'warning'
                });
                return
            }
            if(!this.serve_productType.value){
                this.$message({
                    message: '请选择产品类型',
                    type: 'warning'
                });
                return
            }
            const data = {
                ZAREA_CODE:this.serve_province,
                CITY:this.serve_city,
                producttype1:this.serve_productType.label[0].PID,
                producttype2:this.serve_productType.label[0].ID,
            }
            this.loading = true
            const res = await getStationList(data)
            this.loading = false
            console.log(res)
            if(res.state === 'ok'){
                this.list = res.data
                this.$emit('tag',res.data,'server')
            }
            
        },
        getCity(value){
            // console.log(value)
            let obj = {};
                obj = this.store_city_list.find((item)=>{
                    return item.Id === value;
                });
                console.log(obj.Name);
                this.cityName = obj.Name
        },
        // 获取门店数据
        async getStoreList(){
            const _this = this
            if(!this.store_province){
                this.$message({
                    message: '请选择省',
                    type: 'warning'
                });
                return
            }
            if(!this.store_city){
                this.$message({
                    message: '请选择市',
                    type: 'warning'
                });
                return
            }
            if(!this.store_productType.length){
                this.$message({
                    message: '请选择产品类型',
                    type: 'warning'
                });
                return
            }
            console.log(this.store_productType)
            // let store_productType = '"'
            // this.store_productType.forEach(item => {
            //     store_productType += "'" + item + "'" + ","
            // })
            // store_productType += '"'
            const data = {
                province:this.store_province,
                region:this.store_city,
                producttype:this.store_productType.join(','),
            }
            let state = false
            if(!this.pc){
                data.lng = this.point.lng
                data.lat = this.point.lat
                state = true
            }else{
                if(this.address.city === '北京市'){
                    data.lng = 116.48548
                    data.lat = 39.9484
                    state = true
                }
            }
            this.loading = true
            const res = await getStoreList(data)
            this.loading = false
            console.log(res,1111122222)
            if(res.rows || res.Items){
                // res.rows[0].picture = 'https://support-cn.samsung.com/upload/ApplyDomain/Upload/StoreLocation/202209/27/CS0603955.jpg'
                if(state){
                    _this.list = res.Items
                    if(_this.store_productType.length === 1 && _this.store_productType[0] === 'HHP,TABLET,VPS'){
                        _this.$emit('tag',res.Items,'store1')
                    }else{
                        _this.$emit('tag',res.Items,'store')
                    }
                    
                }else{
                    _this.list = res.rows
                    if(_this.store_productType.length === 1 && _this.store_productType[0] === 'HHP,TABLET,VPS'){
                        _this.$emit('tag',res.Items,'store1')
                    }else{
                        _this.$emit('tag',res.Items,'store')
                    }
                }
                this.$parent.selectCity(_this.cityName)
                
            }
            
        },
        //获取搜索标签
        async getKeyWordList(){
            const res = await getKeyWordList()
            console.log(res)
            if (res) {
                this.labelList = res
            }
        },
        //获取搜索列表
        async getQuickSearchList(page){
            const data = {
                pageindex:page,
                nameoraddress:this.storeName,
                storetype:this.labelState.join(','),
                province:this.store_province,
                region:this.store_city,
            }
            this.loading = true
            let state = false
            if(!this.pc){
                data.lng = this.point.lng
                data.lat = this.point.lat
                state = true
            }else{
                if(this.address.city === '北京市'){
                    data.lng = 116.48548
                    data.lat = 39.9484
                    state = true
                }
            }
            const res = await getQuickSearchList(data)
            this.loading = false
            if(res) {
                console.log(1111111111)
                if(page === 1){
                console.log(222222222222)

                    if(res.Items.length > 0){
                        this.list1 = res.Items
                    } else {
                        this.list1 = []
                    }
                } else {
                console.log(33333333333333)

                    if(res.Items.length > 0){
                        this.list1 = this.list1.concat(res.Items)
                    }
                }
                this.total = res.TotalPages
                console.log(this.total,this.page)
                if(this.page >= this.total){
                    this.isPage = false
                }
                this.$emit('tag',this.list1,'search',page)
            }
        },
        chooseTyle(data){
            this.serve_productType.label = []
            this.serve_productType.label.push({
                label:data.Name,
                value:data.ID,
                ID:data.ID,
                PID:data.PID,
            })
            this.serve_productType.value = data.ID
            this.$refs.configSelect6.blur();
            // if(this.serve_productType.value.indexOf(data.ID) === -1){
            //     this.serve_productType.value.push(data.ID)
            //     this.serve_productType.label.push({
            //         label:data.Name,
            //         value:data.ID,
            //         ID:data.ID,
            //         PID:data.PID,
            //     })
            // }else{
            //     this.serve_productType.value.some((item, i) => {
            //         if (item === data.ID) {
            //             this.serve_productType.value.splice(i, 1)
            //             this.serve_productType.label.splice(i, 1)
            //         }
            //     })
            // }
            console.log(this.serve_productType)
        },
        removeProductType(e){
            this.serve_productType = {
                label:[],
                value:null
            }
        },
        /** 
         * json格式转树状结构 
         * @param   {json}      json数据 
         * @param   {String}    id的字符串 
         * @param   {String}    父id的字符串 
         * @param   {String}    children的字符串 
         * @return  {Array}     数组 
         */
        toTree(data, idStr, pidStr, chindrenStr){  
            var a = JSON.parse(JSON.stringify(data))
            var r = [], hash = {}, id = idStr, pid = pidStr, children = chindrenStr, i = 0, j = 0, len = a.length;  
            for(; i < len; i++){  
                hash[a[i][id]] = a[i];  
            }  
            for(; j < len; j++){  
                var aVal = a[j], hashVP = hash[aVal[pid]];  
                if(hashVP){  
                    !hashVP[children] && (hashVP[children] = []);  
                    hashVP[children].push(aVal);  
                }else{  
                    r.push(aVal);  
                }  
            }  
            return r;  
        },
        input1:debounce(function(e){
          console.log(this.storeName);
          if(this.labelState.length === 0 && this.storeName === ''){
                this.list1 = []
                // this.$parent.map.clearOverlays()
            }else{
                this.isPage = true
                this.page = 1
                this.getQuickSearchList(this.page)
            }
        }, 1000),
        handleChange(val) {
            console.log(val);
            if(val == 1){
                this.labelState = []
                this.list1 = []
                // this.page = 1
                // this.getQuickSearchList(this.page)
            }
            if(val ==3){
                this.storeName = ''
                this.labelState = this.labelList.map(item => {
                    return item.Abbr
                })
                this.page = 1
                this.getQuickSearchList(this.page)
                this.buriedPt('cn:experience store:suoyou', 'o')
            }
        },
        input2:debounce(function(e){
          console.log(this.serverName);
        }, 200),
        tabSwitch(type){
            // this.query_productType = []
            // this.store_productType = []
            // this.store_province = ''
            // this.store_city = ''
            // this.serve_productType = {
            //     label:[],
            //     value:null
            // }
            // this.serve_province = ''
            // this.serve_city = ''
            // this.serverName = ''
            // this.storeName = ''
            // this.activeNames = ['1']
            // this.list = []
            this.tabState = type
            // this.page = 1
            // this.isPage = true
            // this.total = 0
            this.$emit('tabSwitch')
        },
        labelSwitch(id){
            // this.labelState = type
            if(this.labelState.indexOf(id) === -1) {
                this.labelState.push(id)
            } else {
                let index = this.labelState.indexOf(id)
                this.labelState.splice(index,1)
            }
            if(this.labelState.length === 0 && this.storeName === ''){
                this.list1 = []
                // this.$parent.map.clearOverlays()
            }else{
                this.isPage = true
                this.page = 1
                this.getQuickSearchList(this.page)
            }
           if (id == 5){
            this.buriedPt('cn:experience store:dianshi/yingyin', 'o')
           }
           if (id == 6){
            this.buriedPt('cn:experience store:bingxiang/xiyiji', 'o')
           }
           if (id == 7){
            this.buriedPt('cn:experience store:kuaishandian', 'o')
           }
           if (id == 1){
            this.buriedPt('cn:experience store:shouquantiyandian', 'o')
           }
           if (id == 2){
            this.buriedPt('cn:experience store:quanchanpinzhuanmaidian', 'o')
           }
        },
        labelSwitchAll(){
            if(this.labelList.length === this.labelState.length){
                this.labelState = []
            } else {
                this.labelState = this.labelList.map(item => {
                    return item.Abbr
                })
            }
            if(this.labelState.length === 0 && this.storeName === ''){
                this.list1 = []
            }else{
                this.isPage = true
                this.page = 1
                this.getQuickSearchList(this.page)
            }
            this.buriedPt('cn:experience store:suoyou', 'o')
        },
        closeselect(){
            this.$refs.configSelect.blur();
            this.$refs.configSelect1.blur();
            this.$refs.configSelect2.blur();
            this.$refs.configSelect4.blur();
            this.$refs.configSelect5.blur();
            this.$refs.configSelect6.blur();
        },
        // {lnglat:[116.35199959241,40.087836422292], city: '北京市', name:'昌平区'}
        getDirections(param,type){
            this.$emit("getLocation",param,type)
            // baiduNavigate({lnglat:[], city: '北京市', name:'请输入起点'},{lnglat:[116.399120,39.889210], city: '北京市', name:'天坛公园'})
        },
        load () {
            console.log('触发分页。。。。。')
            if(this.tabState === '4' && this.list1.length > 0 && !this.loading && this.isPage){
                this.page++
                this.getQuickSearchList(this.page)
            }
        },
        checkStore(data,type){
            // if(this.pc){
                this.$emit('checkStore',data,type)
            // }
        }
    }
}
</script>

<style scoped lang="scss">
 $base-font-size: 720;
@function vw($px) {
  @return ($px / $base-font-size) * 100vw;
}
.menuBox{
    width: 100%;
    .active{
        background-color: #fff;
        color:#5361b9;
    }
    .tabPlaceholder{
        width: 100%;
        height: vw(124.4);
    }
    .tabs{
        display: flex;
        width: 100%;
        height: vw(124.4);
        background-color: #1d2023;
        box-sizing:border-box;
        color:#fff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1000;
        overflow:hidden;
        .tab{
            flex: 1;
            padding: vw(20) 0;
            height: 100%;
            img{
                width: vw(44);
                height: vw(44);
                display: block;
                margin:0 auto;
                // margin-top: vw(20);
            }
            p{
                text-align: center;
                // font-size: vw(26);
                font-size: 14px;
                padding-top: vw(4);
            }
        }
    }
    .content{
        overflow-y: auto;
        height: calc(100vh - vw(124.4));
        background-color: #eeeeee;
        // margin-top:vw(58);
        .mt20_m{
            margin-top: vw(20);
        }
        width: 100%;
        .action{
            padding: 0 vw(15);
            background-color: #fff;
            box-sizing: border-box;
            .action-query{
                padding: vw(27) 0;
                box-sizing: border-box;
                .action-query-btn{
                    // width: 100%;
                    height: vw(70);
                    line-height: vw(70);
                    text-align: center;
                    border-radius: vw(70);
                    font-size: vw(22);
                    background-color: #1428a0;
                    color:#fff;
                    margin-top: vw(20);
                }
                
            }
        }
        .search{
            width: 100%;
            .search-item{
                // padding: 0 25px;
                // display: flex;
                // flex-wrap: wrap;
                // // justify-content: space-between;
                // align-items: flex-start;
                display: flex; 
                flex-flow: row wrap;
                .label.active{
                    border: 1px solid #0077c8;
                    color:#0077c8;
                }
                .label{
                    padding: 0 vw(50);
                    height: vw(60);
                    line-height: vw(60);
                    // font-size: vw(30);
                    font-size: vw(26);
                    border-radius: vw(30);
                    border: 1px solid #969696;
                    color:#969696;
                    box-sizing: border-box;
                    margin-right: vw(12);
                    margin-bottom: vw(20);
                    cursor: pointer;
                }
            }
        }
        .list{
            width: 100%;
            padding: vw(18) vw(15);
            background-color: #eeeeee;
            box-sizing: border-box;
            .item1{
                width: 100%;
                min-height: vw(150);
                background-color: #fff;
                border-radius: vw(40);
                position: relative;
                // padding: vw(60) vw(44);
                padding: vw(30) vw(30) vw(30) vw(74);
                box-sizing: border-box;
                overflow: hidden;
                margin-bottom: vw(18);
                cursor: pointer;
                .itemL{
                    float: left;
                    width: vw(370);
                    .p1 {
                        font-size: vw(26);
                        font-weight: 600;
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        line-height: vw(30);
                        margin-top: vw(10);
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                        overflow: hidden;

                        span {
                            display: inline-block;
                        }

                        span:nth-child(2) {
                            font-size: vw(16);
                            color: #1470b9;
                        }
                    }

                    .p2 {
                        font-size: vw(22);
                        margin-top: vw(26);
                        line-height: vw(25);
                    }

                    .p3 {
                        font-size: vw(22);
                        margin-top: vw(10);
                        line-height: vw(24);
                    }

                    .p4 {
                        font-size: vw(22);
                        margin-top: vw(50);
                        // padding-left: vw(34);
                        color: #da4b44;
                    }
                    .icon1{
                        background: url(../../assets/img/icon2.png) !important;
                        background-size: cover !important;  
                        line-height: vw(52) !important;
                    }
                    .icon{
                        width: vw(67);
                        height: vw(80);
                        position:absolute;
                        left: vw(10);
                        top: vw(25);
                        background: url(../../assets/img/icon1.png);
                        background-size: 100% 100%;
                        
                        span{
                            display: inline-block;
                            // font-size: vw(10);
                            // zoom: 0.8;
                            // margin-top: vw(20);
                            // width: vw(68);
                            text-align: center;
                            width: vw(66);
                            line-height: vw(50);
                            font-size: vw(30);
                            transform: scale(0.5);
                        }
                        // .scale{
                        //     transform: scale(0.6);
                        // }
                    }
                }
                .itemR{
                    float: right;
                    width: vw(180);
                    height: vw(180);
                    border-radius: vw(20);
                    overflow: hidden;
                    img{
                        width: vw(180);
                        height: vw(180);
                    }
                }
                
            }
        }
    }
    
}
// .menuBox1::-webkit-scrollbar { width: 0 !important }
.menuBox1{
    width: 100%;
    position: relative;
    .active{
        background-color: #fff;
        color:#5361b9;
    }
    .tabPlaceholder{
        width: 100%;
        height: 60px;
    }
    .tabs{
        display: flex;
        width: 100%;
        height: 60px;
        background-color: #1d2023;
        box-sizing:border-box;
        color:#fff;
        position: absolute;
        top:0;
        left: 0;
        overflow:hidden;
        .active{
            background-color: #fff;
            color:#5361b9;
        }
        .tab{
            flex: 1;
            padding: 7px 0;
            cursor: pointer;
            height: 100%;
            img{
                width: 30px;
                height: 30px;
                display: block;
                margin:0 auto;
                // margin-top: vw(20);
            }
            p{
                text-align: center;
                font-size: 12px;
                padding-top: 2px;
            }
        }
    }
    .content::-webkit-scrollbar { width: 0 !important }

    .content{
        overflow-y: auto;
        max-height: calc(96.6vh - 60px);
        .mt20_m{
            margin-top: 15px;
        }
        width: 100%;
        .action{
            padding: 0 15px;
            background-color: #fff;
            box-sizing: border-box;
            .action-query{
                padding: 27px 0;
                box-sizing: border-box;
                .action-query-btn{
                    // width: 100%;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    border-radius: vw(20);
                    font-size: 16px;
                    background-color: #1428a0;
                    color:#fff;
                    margin-top: 15px;
                    cursor: pointer;
                }
            }
        }
        .search{
            width: 100%;
            .search-item{
                // padding: 0 25px;
                // display: flex;
                // flex-wrap: wrap;
                // // justify-content: space-between;
                // align-items: flex-start;
                display: flex; 
                flex-flow: row wrap;
                .label.active{
                    border: 1px solid #0077c8;
                    color:#0077c8;
                }
                .label{
                    padding: 0 25px;
                    height: 30px;
                    line-height: 30px;
                    font-size: 16px;
                    border-radius: 22px;
                    border: 1px solid #969696;
                    color:#969696;
                    box-sizing: border-box;
                    margin-right: 6px;
                    margin-bottom: 10px;
                    cursor: pointer;
                }
            }
        }
        .list{
            width: 100%;
            padding: vw(10) vw(10);
            background-color: #eeeeee;
            box-sizing: border-box;
            .item1{
                width: 100%;
                min-height: 150px;
                background-color: #fff;
                border-radius: 20px;
                position: relative;
                // padding: vw(60) vw(44);
                padding: 23px 10px 23px 50px;
                box-sizing: border-box;
                overflow: hidden;
                margin-bottom: 15px;
                .itemL{
                    float: left;
                    width: 180px;
                    .p1 {
                        font-size: 14px;
                        font-weight: 600;
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        line-height: 16px;
                        margin-top: 10px;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                        overflow: hidden;

                        span {
                            display: inline-block;
                        }

                        // span:nth-child(2) {
                        //     font-size: vw(16);
                        //     color: #1470b9;
                        // }
                    }

                    .p2 {
                        font-size: 12px;
                        margin-top: 17px;
                        line-height: 14px;
                    }

                    .p3 {
                        font-size: 12px;
                        margin-top: 8px;
                        line-height: 14px;
                    }

                    .p4 {
                        font-size: 12px;
                        margin-top: 35px;
                        // padding-left: vw(34);
                        color: #da4b44;
                        cursor: pointer;
                    }
                    .icon1{
                        background: url(../../assets/img/icon2.png) !important;
                        background-size: cover !important;  
                        span{
                            margin-top: 11px !important;
                        }
                    }
                    .icon{
                        width:41px;
                        height: 44px;
                        position:absolute;
                        left: 11px;
                        top: 22px;
                        background: url(../../assets/img/icon1.png);
                        background-size: cover;
                        
                        span{
                            display: inline-block;
                            font-size: 12px;
                            margin-top: 10px;
                            width: 40px;
                            // zoom:0.9;
                            text-align: center;
                            transform: scale(0.8);
                        }
                    }
                }
                .itemR{
                    float: right;
                    width: 100px;
                    height: 100px;
                    border-radius: 20px;
                    overflow: hidden;
                    img{
                        width: 100px;
                        height: 100px;
                    }
                }
                
            }
        }
    }
}
.ml60_m{
    margin-left: vw(60);
}
.ml60_p{
    margin-left: vw(20);
}
.mr10{
    margin-right: 10px;
}
.mb10{
    margin-bottom: 10px;
}
.pointer{
    cursor: pointer;
}
</style>
<style lang="scss">
 $base-font-size: 720;
@function vw($px) {
  @return ($px / $base-font-size) * 100vw;
}
// .searchInput .el-input .el-input__wrapper{
//     height: 35px !important;
// }
.el-input .el-input__wrapper{
    border-radius: 20px !important;
    min-height: 35px;
    // height: 30px;
}
.el-select .el-input__wrapper{
    border-radius: 40px !important;
    // height: 50px;
}
.menuBox1 .el-select .el-input__wrapper{
    min-height: 35px;
    padding-left: vw(20);
    padding-right: vw(15);
}
.menuBox .el-select .el-input__wrapper{
    min-height: vw(70);
    padding-left: vw(60);
    padding-right: vw(40);
}
.menuBox1 .el-collapse-item__header{
    height: 70px !important;
    box-sizing: border-box !important;
    font-weight: 600 !important;
    // font-size: vw(10) !important;
    font-size: 16px !important;
    padding: 0 25px;
}
.menuBox .el-collapse-item__header{
    height: vw(121) !important;
    box-sizing: border-box !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    // font-size: vw(22) !important;
    padding-left: vw(34);
    padding-right: vw(40);
}
.menuBox1 .el-collapse-item__content{
    padding: 0 25px 20px 25px;
}
.menuBox .el-collapse-item__content{
    padding-left: vw(34);
    padding-right: vw(40);
}
// .el-select .el-input.is-focus .el-input__wrapper{
//     box-shadow: 0 0 0 1px #b5b5b5 !important;
// }
// .el-select .el-input_wrapper.is-focus{
//     box-shadow: 0 0 0 1px #b5b5b5 !important;
// }
.el-select-dropdown {
  position: absolute !important;
  left: -1px !important;
  top: -22px !important;
//   top: -15px !important;
  border: 1px solid #b5b5b5;
//   background-color: #fff;
  border-radius: 0 0 20px 20px !important;
  padding-top: 15px;
  border-top:none;
  overflow: hidden;
//   margin-left: -1px !important;
//   margin-top: -22px !important;
}
// .elSelect ::v-deep .el-input__inner{
//     height: vw(40) !important;
// }
.el-select,*{
        -webkit-tap-highlight-color: transparent !important;
    } 
.el-input__inner {
   border-color: #b5b5b5  !important;
   font-size: 16px !important;
   transform: scale(.9) !important;
//    height: 15px !important;
}

input, input:focus,
textarea, textarea:focus,
select, select:focus {
  font-size: 16px !important;
}
.el-select .el-input_wrapper.is-focus,.el-select .el-input.is-focus .el-input__wrapper{
    box-shadow: 0 0 0 1px #b5b5b5 !important;
}

.selectCls{
    
}
.el-select .el-select-tags-wrapper.has-prefix{
    padding-left:15px;
}
.el-select .el-select__tags .el-select-tags-wrapper .el-tag--info{
    background-color: #fff !important;
    font-size: 14px;
    // display:none;
    padding:0;
}
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(3),
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(1),
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(2){
//     display:inline-block;
// }
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(1),
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(2){
//     position: relative;
//     top: 1px;
// }
// .menuBox .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(1) .el-tag__content .el-select__tags-text,
// .menuBox .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(2) .el-tag__content .el-select__tags-text{
//     width: 80px;
//     overflow: hidden; //超出的文本隐藏
//     text-overflow: ellipsis; //溢出用省略号显示
//     white-space: nowrap;  // 默认不换行；
// }
// .menuBox1 .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(1) .el-tag__content .el-select__tags-text,
// .menuBox1 .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(2) .el-tag__content .el-select__tags-text{
//     width: 90px;
//     overflow: hidden; //超出的文本隐藏
//     text-overflow: ellipsis; //溢出用省略号显示
//     white-space: nowrap;  // 默认不换行；
// }
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(3)::before{
//     content: '...';
// }
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(3) .el-tag__content .el-select__tags-text{
//     display:none;
// }
// .el-select .el-select__tags .el-select-tags-wrapper .el-tag--info:nth-child(2){
//     display: none !important;
// }
// .el-select .el-input .el-select__caret.el-icon{
//     padding:10px;
// }
// .menuBox1 .el-tag .el-tag__close,.menuBox .el-tag .el-tag__close{
//     display:none;
// }
.selectCls .el-select-dropdown__empty{
    background-color: #fff;
}
.selectCls .el-popper__arrow{
    display: none;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after{
    display: none !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.selected{
    color:#b5b5b5 !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.is-disabled{
    cursor:auto !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.selected .icon{
    border: none;
    background-color: #0077c8;
}

.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox{
    padding: 10px;
    padding-left: 10px !important;
    // min-height: 200px;
    // max-height: 400px;
    height: auto;
    display: block !important;
    overflow-y:auto;
    background-color: #fff;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox::-webkit-scrollbar {
          width: 5px !important;
          height: 5px !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox::-webkit-scrollbar-thumb {
          background: #b5b5b5;
          border-radius: 3px;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType{
    background-color: #fff;
    width: 100%;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse{
    max-width: 320px;
    width: 100%;
    border:none !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__header{
    border:none !important;
    padding-left: 0;
    height: 35px;
    line-height: 35px;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__content{
    padding-bottom: 0;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__header .el-icon{
    display:none !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__wrap{
    width: 100%;
    word-wrap: break-word !important;
    word-break: normal !important;
    border:none !important;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__wrap .tabBox{
    display: flex;
    flex-wrap: wrap;
    padding-left: 45px;
}

.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__wrap .tagSelect,.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__wrap .tagSelect{
    color:#fff;
    background-color: #0077c8;
}
.selectCls .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox .iconS,.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox .iconS{
    background-color: #0077c8;
    border:none !important;
}

.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox{
    padding: 10px;
    padding-left: 10px !important;
    // min-height: 200px;
    // max-height: 400px;
    height: auto;
    display: block !important;
    overflow-y:auto;
    background-color: #fff;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox::-webkit-scrollbar {
          width: 5px !important;
          height: 5px !important;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item.productTypeBox::-webkit-scrollbar-thumb {
          background: #b5b5b5;
          border-radius: 3px;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType{
    background-color: #fff;
    width: 100%;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse{
    max-width: 320px;
    width: 100%;
    border:none !important;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__header{
    border:none !important;
    padding-left: 0;
    height: 35px;
    line-height: 35px;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__content{
    padding-bottom: 0;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__header .el-icon{
    display:none !important;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__wrap{
    width: 100%;
    word-wrap: break-word !important;
    word-break: normal !important;
    border:none !important;
}
.selectCls1 .el-select-dropdown.is-multiple .el-select-dropdown__item .productType .el-collapse .el-collapse-item__wrap .tabBox{
    display: flex;
    flex-wrap: wrap;
    padding-left: vw(100);
}


.selectCls .el-scrollbar .el-select-dropdown__wrap{
    background-color: #fff;
}
.selectCls .el-scrollbar .el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item {
    display:flex;
    // justify-content:center;
    align-items:center;
    font-size: 14px;
//   padding-left: vw(60);
    padding-left: 0;

}
.selectCls .el-scrollbar .el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item .icon{
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid #b5b5b5;
    float: left;
    margin-right: 15px;
}
.selectCls1 .el-scrollbar .el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item .icon{
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid #b5b5b5;
    float: left;
    margin-right: 15px;
}

.selectCls .el-select-dropdown .el-select-dropdown__item.selected{
    color:#868686 !important;
}
.selectCls .el-select-dropdown .el-select-dropdown__item.selected .icon{
    border: none;
    background-color: #0077c8;
}
</style>